import React, { useEffect } from "react";
import { FaSquareUpwork } from "react-icons/fa6";

function App() {
  useEffect(() => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches || "ontouchstart" in window;

    // Cursor follow (desktop only)
    let handleMouseMove = null;
    let handleMouseEnter = null;
    let handleMouseLeave = null;

    if (!isMobile) {
      handleMouseMove = (e) => {
        let cursor = document.querySelector(".cursor");
        if (!cursor) {
          const newCursor = document.createElement("div");
          newCursor.className = "cursor";
          document.body.appendChild(newCursor);
          cursor = newCursor;
        }
        cursor.style.left = e.clientX - 14 + "px";
        cursor.style.top = e.clientY - 14 + "px";
      };

      document.addEventListener("mousemove", handleMouseMove);

      handleMouseEnter = () => {
        const cursor = document.querySelector(".cursor");
        if (cursor) {
          cursor.style.transform = "scale(2)";
          cursor.style.background =
            "radial-gradient(circle, rgba(232, 212, 168, 0.8), transparent 70%)";
        }
      };

      handleMouseLeave = () => {
        const cursor = document.querySelector(".cursor");
        if (cursor) {
          cursor.style.transform = "scale(1)";
          cursor.style.background =
            "radial-gradient(circle, rgba(201, 169, 110, 0.55), transparent 70%)";
        }
      };

      document
        .querySelectorAll("a, .cv-entry, .project-entry")
        .forEach((el) => {
          el.addEventListener("mouseenter", handleMouseEnter);
          el.addEventListener("mouseleave", handleMouseLeave);
        });
    }

    return () => {
      if (handleMouseMove) document.removeEventListener("mousemove", handleMouseMove);
      if (handleMouseEnter && handleMouseLeave) {
        document
          .querySelectorAll("a, .cv-entry, .project-entry")
          .forEach((el) => {
            el.removeEventListener("mouseenter", handleMouseEnter);
            el.removeEventListener("mouseleave", handleMouseLeave);
          });
      }
    };
  }, []);

  return (
    <div className="App">
      <div className="bg-animation"></div>

      <a className="view-switch" href="/" title="Switch to the 3D room portfolio">
        <i className="fas fa-cube"></i> Enter the 3D room
      </a>

      <main className="cv">
        {/* ===== Header ===== */}
        <header className="cv-header">
          <img className="avatar" src={`${process.env.PUBLIC_URL}/me.png`} alt="Santosh Giri" />
          <h1>Santosh Giri</h1>
          <p className="role">Fullstack Developer</p>
          <a className="cert-badge" href="https://aws.amazon.com/verification" target="_blank" rel="noopener noreferrer" title="Verify with validation number e226fedb93494e96b4aeb851535dfb69">
            <i className="fab fa-aws"></i> AWS Certified Solutions Architect – Associate
          </a>
          <div className="contact-line">
            <span>Kathmandu, Nepal</span>
            <span className="dot">•</span>
            <a href="tel:+9779815054626">+977-9815054626</a>
            <span className="dot">•</span>
            <a href="mailto:mail@santoshgiri.com.np">mail@santoshgiri.com.np</a>
          </div>
          <div className="contact-line links">
            <a href="https://linkedin.com/in/santoshhgiri" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin"></i> linkedin.com/in/santoshhgiri
            </a>
            <span className="dot">•</span>
            <a href="https://github.com/santosh2345" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-github"></i> github.com/santosh2345
            </a>
            <span className="dot">•</span>
            <a href="https://santoshgiri.com.np" target="_blank" rel="noopener noreferrer">
              <i className="fas fa-globe"></i> santoshgiri.com.np
            </a>
            <span className="dot">•</span>
            <a href="https://www.upwork.com/freelancers/~0132bf1a20c97b4bf4" target="_blank" rel="noopener noreferrer">
              <FaSquareUpwork /> Upwork
            </a>
          </div>

          <p className="summary">
            Fullstack Developer and AWS Certified Solutions Architect – Associate (SAA-C03) with 4+ years
            of experience specializing in modern web and mobile
            application development using React.js, Node.js, Next.js, React Native, TypeScript, and a
            wide range of backend and frontend technologies. Proven track record in building scalable
            applications, leading technical teams, mentoring interns, and delivering production-grade
            apps with optimized performance and solid architecture. Adept in both monolithic and
            microservices architecture, and passionate about building tools that solve real-world problems.
          </p>

          <a className="cv-download" href={`${process.env.PUBLIC_URL}/SANTOSH-GIRI-RESUME.pdf`} download="Santosh-Giri-Resume.pdf">
            <i className="fas fa-download"></i> Download PDF
          </a>
        </header>

        {/* ===== Certification ===== */}
        <section className="cv-section">
          <h2>Certification</h2>
          <article className="cv-entry cert-entry">
            <div className="entry-head">
              <div>
                <h3>
                  <a href="https://aws.amazon.com/verification" target="_blank" rel="noopener noreferrer">
                    AWS Certified Solutions Architect – Associate
                  </a>{" "}
                  <span className="cert-code">SAA-C03</span>
                </h3>
                <p className="meta">Amazon Web Services (AWS)</p>
              </div>
              <span className="date">Oct 2026 – Oct 2029</span>
            </div>
            <p>Validated skills in designing secure, resilient, high-performing, and cost-optimized architectures on AWS, applied day to day with EC2, S3, and Lambda in production.</p>
            <p className="cert-verify">
              Validation number <code>e226fedb93494e96b4aeb851535dfb69</code> · verify at{" "}
              <a href="https://aws.amazon.com/verification" target="_blank" rel="noopener noreferrer">aws.amazon.com/verification</a>
            </p>
          </article>
        </section>

        {/* ===== Experience ===== */}
        <section className="cv-section">
          <h2>Experience</h2>

          <article className="cv-entry">
            <div className="entry-head">
              <div>
                <h3>Fullstack Developer, <a href="https://blanxer.com" target="_blank" rel="noopener noreferrer">Blanxer Technology</a></h3>
                <p className="meta">blanxer.com.np / sambad.io · Kathmandu, Nepal · Onsite</p>
              </div>
              <span className="date">May 2025 – Present</span>
            </div>
            <ul>
              <li>Working on <a href="https://www.sambad.io" target="_blank" rel="noopener noreferrer">Sambad</a>, an AI-powered omnichannel platform unifying WhatsApp, Instagram, Facebook, TikTok, web chat, and email; AI auto-responds and sends product cards directly in chat, with human handoff for complex leads.</li>
              <li>Sambad AI supports eCommerce, bookings, real estate, hotels, and order management, automated and manual, calling connected order, CRM, and calendar systems for real-time answers in chat.</li>
              <li>Contributing to a multi-tenant SaaS eCommerce site builder (MERN): inventory, POS, order management, custom domain setup, and site editor.</li>
              <li>Implemented messaging integrations using webhooks, Redis, and BullMQ for scalable background processing.</li>
              <li><em>Tech:</em> MERN, AWS (EC2, S3), PM2, Redis, BullMQ, Webhooks, FCM, REST APIs.</li>
            </ul>
          </article>

          <article className="cv-entry">
            <div className="entry-head">
              <div>
                <h3>Fullstack Developer, <a href="https://techsense.com.np" target="_blank" rel="noopener noreferrer">Techsense</a></h3>
                <p className="meta">techsense.com.np · Kathmandu, Nepal · Hybrid</p>
              </div>
              <span className="date">Feb 2025 – Feb 2026</span>
            </div>
            <ul>
              <li>Worked closely with Japanese teams on product development, adapting to their business hours and quality standards.</li>
              <li>Built scalable eCommerce platform with order/cart management, Esewa payment integration, and Gallimap integration.</li>
              <li>Implemented role-based access control, JWT authentication, efficient Redux Saga side effects, and i18n.</li>
              <li>Developed and maintained PostgreSQL schemas using TypeORM with transactional support and migrations.</li>
              <li>Designed responsive UI with Styled Components; ensured consistent error handling across UI/backend.</li>
            </ul>
          </article>

          <article className="cv-entry">
            <div className="entry-head">
              <div>
                <h3>Mentor &amp; Fullstack Developer, <a href="https://kharaayo.com" target="_blank" rel="noopener noreferrer">Kharaayo Inc.</a></h3>
                <p className="meta">kharaayo.com · Birtamod, Nepal · Onsite</p>
              </div>
              <span className="date">Feb 2025 – Sep 2025</span>
            </div>
            <ul>
              <li>Guided interns and students through real-world MERN stack development.</li>
              <li>Conducted live sessions and mentoring on React.js, Node.js, Git, and software design best practices.</li>
            </ul>
          </article>

          <article className="cv-entry">
            <div className="entry-head">
              <div>
                <h3>React Native Developer, <a href="https://crystalsolution.com.np" target="_blank" rel="noopener noreferrer">Crystal Solutions</a></h3>
                <p className="meta">crystalsolution.com.np · Birtamod, Nepal · Onsite</p>
              </div>
              <span className="date">Jul 2024 – Aug 2025</span>
            </div>
            <ul>
              <li>Developed and deployed 3 cross-platform mobile apps using React Native &amp; Expo.</li>
              <li>Built POS and College Campus apps with offline mode (SQLite), MMKV storage, and file-based routing.</li>
              <li>Implemented navigation, error boundaries, UI optimization, crash prevention, and state management with Zustand.</li>
              <li>Published apps on Play Store; used EAS CLI for smooth updates and releases.</li>
            </ul>
          </article>

          <article className="cv-entry">
            <div className="entry-head">
              <div>
                <h3>Frontend Developer, <a href="http://www.capitechnepal.com" target="_blank" rel="noopener noreferrer">Capitech Nepal</a></h3>
                <p className="meta">capitechnepal.com · Kathmandu, Nepal · Remote</p>
              </div>
              <span className="date">Apr 2022 – Apr 2023</span>
            </div>
            <ul>
              <li>Worked on multi-step forms in Next.js platform using React Hook Form, Zod, and Tailwind CSS.</li>
              <li>Built responsive UIs, modal systems, and reusable component libraries.</li>
            </ul>
          </article>
        </section>

        {/* ===== Education ===== */}
        <section className="cv-section">
          <h2>Education</h2>
          <article className="cv-entry">
            <div className="entry-head">
              <div>
                <h3>BSc. Computer Science and Information Technology (BSc.CSIT)</h3>
                <p className="meta">Mechi Multiple Campus · Tribhuvan University · Jhapa, Nepal</p>
              </div>
              <span className="date">Apr 2020 – Jan 2025</span>
            </div>
          </article>
        </section>

        {/* ===== Projects ===== */}
        <section className="cv-section">
          <h2>Projects</h2>

          <article className="project-entry featured">
            <div className="rec" aria-hidden="true">
              <span className="rec-dot"></span>REC<span className="rec-tc">00:00</span>
              <span className="rec-spec">1080p · 30 fps · Lambda</span>
            </div>
            <div className="entry-head">
              <h3>Drishya</h3>
              <a className="date link" href="https://drishya.santoshgiri.com.np" target="_blank" rel="noopener noreferrer">drishya.santoshgiri.com.np</a>
            </div>
            <p>AI marketing-video SaaS with a composition-based render engine. Generates branded promo videos end-to-end: scrapes a brand's site to extract colors, fonts, and logos (Puppeteer, Cheerio, node-vibrant), writes scripts with Claude and Gemini, synthesizes voiceover (Edge TTS), and renders programmatic compositions via Remotion on AWS Lambda with S3 storage.</p>
            <p className="tech"><em>Tech:</em> Remotion, AWS Lambda + S3, Claude &amp; Gemini, Edge TTS, Puppeteer, Cheerio, Next.js 15, React 19, Motion, TypeScript, Docker.</p>
          </article>

          <article className="project-entry featured oss">
            <div className="oss-meta" aria-hidden="true">
              <span className="oss-star">★ 3.5k</span>
              <span className="oss-tag">Open Source</span>
              <span className="oss-prs">3 PRs merged</span>
            </div>
            <div className="entry-head">
              <h3>Corsair: Unified Integration Layer for Agents</h3>
              <a className="date link" href="https://github.com/corsairdev/corsair" target="_blank" rel="noopener noreferrer">github.com/corsairdev/corsair</a>
            </div>
            <p>Contributor to Corsair (3.5k★), a TypeScript framework that gives agents safe, permissioned access to every integration via MCP. Three PRs merged into <code>main</code>:</p>
            <ul className="oss-list">
              <li><a href="https://github.com/corsairdev/corsair/pull/184" target="_blank" rel="noopener noreferrer">#184</a>: built the Studio <strong>Chat page</strong>: streaming SSE chat UI wired to Corsair MCP tools (list_operations, get_schema, run_script), multi-step tool use via the Vercel AI SDK, provider-agnostic (OpenAI / Anthropic / Google / Groq).</li>
              <li><a href="https://github.com/corsairdev/corsair/pull/207" target="_blank" rel="noopener noreferrer">#207</a>: per-message and per-chat <strong>token usage + cost</strong> tracking, with a model-pricing table and graceful fallback for unknown models.</li>
              <li><a href="https://github.com/corsairdev/corsair/pull/251" target="_blank" rel="noopener noreferrer">#251</a>: shipped the <strong>Zoho Mail plugin</strong>: OAuth2, multi-region datacenters, message + folder endpoints, and signature-verified webhooks.</li>
            </ul>
          </article>

          <article className="project-entry">
            <div className="entry-head">
              <h3>ShareX: E2EE File Sharing</h3>
              <a className="date link" href="https://github.com/santosh2345/ShareX" target="_blank" rel="noopener noreferrer">github.com/santosh2345/ShareX</a>
            </div>
            <p>Secure file transfer platform with client-side encryption using AES-GCM and ECDH, with digital signature verification.</p>
          </article>

          <article className="project-entry">
            <div className="entry-head">
              <h3>VocabMate: Chrome Extension</h3>
              <a className="date link" href="https://chromewebstore.google.com/detail/gaojjonfjbhodicdeiaadcbkfceklhih" target="_blank" rel="noopener noreferrer">Chrome Web Store</a>
            </div>
            <p>Published Chrome extension (Manifest V3) for instant word lookup: hover any word on a page and press <em>v</em> to get its meaning inline. Built with React, TypeScript, Vite, and Tailwind, using a content script + service worker and the Dictionary API; context-aware AI explanations planned next.</p>
          </article>

          <article className="project-entry">
            <div className="entry-head">
              <h3>LunaQuake (NASA Space App Challenge)</h3>
              <a className="date link" href="https://lunaquake.vercel.app" target="_blank" rel="noopener noreferrer">lunaquake.vercel.app</a>
            </div>
            <p>Interactive moonquake visualization using React, ThreeJS, React Globe, and Python data processing.</p>
          </article>

          <article className="project-entry">
            <div className="entry-head">
              <h3>Nepali Movie Streaming Platform</h3>
              <a className="date link" href="https://digitalmoviecorner.vercel.app" target="_blank" rel="noopener noreferrer">digitalmoviecorner.vercel.app</a>
            </div>
            <p>Platform with purchase flow, referral MLM system, streaming via Bunny CDN, built using Next.js, PostgreSQL, Prisma, S3, and Esewa integration.</p>
          </article>
        </section>

        {/* ===== Skills ===== */}
        <section className="cv-section">
          <h2>Skills</h2>
          <dl className="skills-list">
            <div className="skill-row">
              <dt>Frontend</dt>
              <dd>React.js, Next.js, React Native, Redux Saga, Zustand, Tailwind CSS, Styled Components</dd>
            </div>
            <div className="skill-row">
              <dt>Backend</dt>
              <dd>Node.js, Express.js, TypeScript, Java, Spring Boot, TypeORM, Prisma, PostgreSQL, MongoDB, SQLite, REST</dd>
            </div>
            <div className="skill-row">
              <dt>DevOps &amp; Infra</dt>
              <dd>AWS (EC2, S3, Lambda), AWS Solution Architecture (SAA-C03), Docker, Git, GitHub, GitLab, Bunny CDN, EAS Update, Play Store Deployment, PM2</dd>
            </div>
            <div className="skill-row">
              <dt>Auth &amp; Security</dt>
              <dd>JWT, Clerk, Role-Based Auth, Joi Validation, MMKV Storage</dd>
            </div>
            <div className="skill-row">
              <dt>Other</dt>
              <dd>WebSocket, Socket.io, Zod, Joi, Error Boundaries, Payment Integration, SEO</dd>
            </div>
            <div className="skill-row">
              <dt>Tools</dt>
              <dd>Expo, EAS Build/Submit, Postman, Figma, VS Code, Linux</dd>
            </div>
            <div className="skill-row">
              <dt>Languages</dt>
              <dd>Nepali, English, Hindi, German</dd>
            </div>
          </dl>
        </section>

        {/* ===== Certifications ===== */}
        <section className="cv-section">
          <h2>Training &amp; Workshops</h2>

          <article className="cv-entry">
            <div className="entry-head">
              <div>
                <h3>AI &amp; ML Workshop</h3>
                <p className="meta">Hunchha Digital · Organized by BSc.CSIT Dept., Tribhuvan University</p>
              </div>
              <span className="date">2023</span>
            </div>
            <p>Hands-on training on machine learning fundamentals; built a gender classification system using camera input and trained ML models.</p>
          </article>

          <article className="cv-entry">
            <div className="entry-head">
              <div>
                <h3>IoT Workshop</h3>
                <p className="meta">PI Innovations · Organized by BSc.CSIT Dept., Tribhuvan University</p>
              </div>
              <span className="date">2025</span>
            </div>
            <p>Built a remote-controlled car using Arduino, sensors, and microcontrollers. Gained experience with embedded systems and IoT communication.</p>
          </article>
        </section>

        <footer className="cv-footer">
          <p>&copy; {new Date().getFullYear()} Santosh Giri</p>
        </footer>
      </main>
    </div>
  );
}

export default App;
